import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CONFIG } from '../../config';
import { Observable } from 'rxjs';

@Injectable()
export class HttpService {
  public constructor(private readonly http: HttpClient) {
  }

  public get(url: string, opts?: any): Observable<any> {
    return this.request('get', url, null, opts);
  }

  public post(url: string, body: any, opts?: any): Observable<any> {
    return this.request('post', url, body, opts);
  }

  public put(url: string, body: any, opts?: any): Observable<any> {
    return this.request('put', url, body, opts);
  }

  public delete(url: string, opts?: any): Observable<any> {
    return this.request('delete', url, null, opts);
  }

  private request(method: string, url: string, body?: any, opts?: any): Observable<Response> {
    const options = !!opts && opts.hasOwnProperty('withCredentials')
      ? { ...opts }
      : { ...opts, withCredentials: true },

     path = this.getUrl(url);

    return body
      ? this.http[ method ](path, body, options)
      : this.http[ method ](path, options);
  }

  // noinspection JSMethodCanBeStatic
  private getUrl(url: string): string {
    return `${CONFIG.API_URL}${url}`;
  }
}
